import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getPrebookInfo } from '../burger-king-lib/redux/home/actions';

function usePrebookInfo() {
  const { preBookInfo: preBook, isPrebookModalOpened } = useSelector(
    state => state.home
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (!preBook) {
      dispatch(getPrebookInfo());
    }
  }, [isPrebookModalOpened]);

  return {
    preBook
  };
}

export default usePrebookInfo;
